module.exports = __webpack_public_path__ + "img/mesa_l001g.d68f675e.png";